<template>
  <div
    id="form_ecom"
    ref="formJoin"
    :class="formClass"
  >
    <div class="form__title">
      Подключитесь к&nbsp;Boxberry
    </div>
    <div class="form__container">
      <ul class="form__fields">
        <li class="form__field form__field_input">
          <div class="field-input">
            <InputOrganization
              :required="true"
              @change-organization="onEnteredOrganization"
              @keyup-enter="submit"
            />
            <svg
              class="person-icon"
              width="24px"
              height="28px"
            >
              <use xlink:href="#person" />
            </svg>
          </div>
          <ListErrorMessage
            v-if="this.dataError"
            :errorMessage = this.dataError.organization
          />
        </li>
        <li class="form__field form__field_input">
          <div class="field-input">
            <InputPhone
              v-model.lazy="$v.valuePhone.$model"
              :required="true"
              :dynamic-mask="true"
              placeholder="+7(___)___-__-__"
              @blur-phone="onEnteredPhone"
              @keyup-enter="submit"
            />
            <svg
              class="phone-icon"
              width="24px"
              height="24px"
            >
              <use xlink:href="#phone-icon" />
            </svg>
          </div>
          <ListErrorMessage
            v-if="!$v.valuePhone.validatePhone"
            :errorMessage = dataError.phone
          />
        </li>
        <li
          class="form__field form__field_input"
          :class="{'field__error': dataError.site || dataError.link_group}"
        >
          <div class="field-input">
            <InputAddressSite2
              v-model="valueSite"
              :required="false"
              placeholder="Адрес вашего сайта"
              @keyup-enter="submit"
              @blur="onBlurAddressSite"
              @focus="showTextAddressSite = true"
              @input="dataError.site = ''; dataError.link_group = ''"
            />
            <svg
              class="site-icon"
              width="24px"
              height="23px"
            >
              <use xlink:href="#site-icon" />
            </svg>
          </div>
          <ListErrorMessage
            v-if="$v.valueSite.$error && !$v.valueSite.validateSite"
            error-message="Введите ваш сайт в верном формате"
          />
          <ListErrorMessage
            v-else-if="dataError.site"
            :error-message="dataError.site"
          />
          <div
            v-else-if="showTextAddressSite"
            class="text-address-site"
          >
            Пожалуйста, укажите ваш сайт в&nbsp;формате &laquo;boxberry.ru&raquo;. Если у&nbsp;вас еще нет сайта,
            оставьте поле пустым. Если сайтов несколько, укажите основной
          </div>
        </li>
        <li
          class="form__field form__field_input"
          :class="{'field__error': dataError.social_media || dataError.link_group}"
        >
          <div class="field-input">
            <InputSocialMedia
              v-model="valueSocialMedia"
              @keyup-enter="submit"
              @blur="onBlurSocialMedia"
              @focus="showSocialMedia = true"
              @input="dataError.social_media = ''; dataError.link_group = ''"
            />
            <svg
              class="name-icon"
              width="21px"
              height="21px"
            >
              <use xlink:href="#entity" />
            </svg>
          </div>
          <ListErrorMessage
            v-if="$v.valueSocialMedia.$error && !$v.valueSocialMedia.validateLength"
            error-message="Допустимая длина ссылки составляет от 4 до 100 символов"
          />
          <ListErrorMessage
            v-else-if="$v.valueSocialMedia.$error && !$v.valueSocialMedia.validateSocialMediaSymbols"
            error-message="Значение недопустимо. Пример допустимого: vk.com/boxberry_ru, www.instagram.com/acc, https://t.me/acc"
          />
          <ListErrorMessage
            v-else-if="dataError.link_group"
            error-message="Укажите хотя бы одну ссылку на ваш магазин"
          />
          <ListErrorMessage
            v-else-if="dataError.social_media"
            :error-message="dataError.social_media"
          />
          <div
            v-else-if="showSocialMedia"
            class="text-address-site"
          >
            Здесь вы&nbsp;можете указать ник или ссылку на&nbsp;инстаграм, вконтакте, авито,
            озон и&nbsp;др. &mdash;&nbsp;любую ссылку на&nbsp;ваш магазин,
            которая не&nbsp;является сайтом вашей компании.
          </div>
        </li>

        <li class="form__field form__field_input">
          <div class="field-input">
            <InputName
              :required="true"
              @change-name="onEnteredName"
              @keyup-enter="submit"
            />
            <svg
              class="name-icon"
              width="21px"
              height="21px"
            >
              <use xlink:href="#entity" />
            </svg>
          </div>
          <ListErrorMessage
            v-if="this.dataError"
            :errorMessage = this.dataError.name
          />
        </li>
        <li class="form__field form__field_input">
          <div class="field-input">
            <InputEmail
              v-model.lazy="$v.valueEmail.$model"
              :required="true"
              @change-email="onEnteredEmail"
              @keyup-enter="submit"
            />
            <svg
              class="mail-icon"
              width="21px"
              height="21px"
            >
              <use xlink:href="#mail" />
            </svg>
          </div>
          <ListErrorMessage
            v-if="!$v.valueEmail.validateEmail"
            :errorMessage = this.dataError.email
          />
        </li>
        <li class="form__field form__field_input">
          <div class="field-input">
            <InputCitySuggest
              :required="true"
              :typeField="'select'"
              :selectedDefaultCity="true"
              @change-city="onChangeCity"
              @change-city-default="onChangeCity"
              @keyup-enter="submit"
            />
            <svg
              class="arrow-icon"
              width="24px"
              height="14px"
            >
              <use xlink:href="#arrow" />
            </svg>
          </div>
          <ListErrorMessage
            v-if="this.dataError"
            :errorMessage = this.dataError.cityName
          />
        </li>
        <li class="form__checkbox">
          <CheckboxSubscription
            @checkedSubscription="onCheckedSubscription"
          />
        </li>
        <li class="form__checkbox">
          <div class="field-checkbox field-checkbox_with-bg">
            <CheckboxAgreement
              link="/e-commerce/dokumenty/soglasenie-o-konfidencial-nosti-informacii-boksberri-soft "
              @updateChecked="checkboxStatus"
            />
          </div>
        </li>
        <CSRF
          ref="csrfToken"
          @setCSRFToken="setCSRFToken"
        />
        <li class="form__field form__field_input">
          <div class="field-input">
            <Recaptcha
              ref="recaptcha"
              :publicKey="recaptchaKey"
              @verified="dataRecaptcha"
              @expired="removeDataRecaptcha"
            />
          </div>
        </li>
        <a
          class="form__button"
          :class="{'form__button_disabled': !buttonActive }"
          @mouseleave="checkCSRFToken"
          @mouseenter="checkCSRFToken"
          @click="submit"
        >{{ buttonText }}</a>
      </ul>
      <FormSteps />
    </div>
  </div>
</template>
<script>
/* global ym */

import Vue from 'vue';
// eslint-disable-next-line
import Vuelidate from 'vuelidate';
import InputOrganization from '../ComponentsForm/InputOrganization.vue';
import InputPhone from '../ComponentsForm/InputPhone.vue';
import InputName from '../ComponentsForm/InputName.vue';
import InputEmail from '../ComponentsForm/InputEmail.vue';
import InputCitySuggest from '../ComponentsForm/InputCitySuggest.vue';
import CheckboxSubscription from '../ComponentsForm/CheckboxSubscription.vue';
import CheckboxAgreement from '../ComponentsForm/CheckboxAgreement.vue';
import ListErrorMessage from '../ComponentsForm/ListErrorMessage.vue';
import Recaptcha from '../ComponentsForm/Recaptcha.vue';
import FormSteps from '../ComponentsForm/FormSteps.vue';
import formData from '../../helpers/form-data';
import CSRF from '../ComponentsForm/CSRF.vue';
import InputAddressSite2 from '../ComponentsForm/InputAddressSite2.vue';
import InputSocialMedia from '../ComponentsForm/InputSocialMedia.vue';
import {
  validateEmail,
  validatePhone,
  validateSite,
  validateSocialMediaSymbols,
} from '../../helpers/validateForm';

Vue.use(Vuelidate);

// eslint-disable-next-line
const axios = require('axios');
const _ = require('lodash');

export default {

  name: 'FormCooperationEcommerce',
  components: {
    FormSteps,
    Recaptcha,
    InputOrganization,
    InputPhone,
    InputName,
    InputEmail,
    InputCitySuggest,
    CheckboxSubscription,
    CheckboxAgreement,
    ListErrorMessage,
    CSRF,
    InputAddressSite2,
    InputSocialMedia,
  },
  props: {
    formType: {
      type: String,
      default: 'join',
    },
  },
  data() {
    return {
      csrf_token: null,
      validPhone: false,
      checkedCheckbox: false,
      buttonLoad: false,
      recaptchaKey: window.recaptchaKey || null,
      cityKladr: '',
      region: '',
      citySuggest: '',
      valueName: '',
      valueSocialMedia: '',
      valuePhone: '',
      valueEmail: null,
      valueSite: '',
      showTextAddressSite: false,
      showSocialMedia: false,
      cityCode: '',
      cityName: '',
      valueSubscription: null,
      unmaskedPhone: null,
      dataCaptcha: '',
      valueOrganization: '',
      formClass: 'form',
      dataError: {
        email: null,
        phone: null,
      },
      validEmail: null,
    };
  },
  computed: {
    buttonText() {
      return this.buttonLoad ? 'Подождите...' : 'Отправить заявку';
    },
    buttonActive() {
      return this.validEmail && this.validPhone && this.checkedCheckbox;
    },
  },
  created() {
    this.formClass = `${this.formClass} ${this.formClass}_${this.formType}`;
  },
  methods: {
    setCSRFToken(token) {
      this.csrf_token = token;
    },
    checkCSRFToken() {
      // вызываем метод ребенка, и слушаем изменения
      this.$refs.csrfToken.checkCSRFToken();
    },
    checkboxStatus(checked) {
      this.checkedCheckbox = checked;
    },
    onEnteredName(value) {
      this.valueName = value;
    },
    onEnteredPhone(value) {
      this.valuePhone = value.valuePhone;
      this.unmaskedPhone = value.unmasked;
    },
    onEnteredEmail(value) {
      this.valueEmail = value;
    },
    onEnteredOrganization(value) {
      this.valueOrganization = value;
    },
    onCheckedSubscription(value) {
      this.valueSubscription = value;
    },
    onChangeCity(value) {
      if (value) {
        this.cityCode = value.Code;
        this.cityName = value.Name;
      } else {
        this.cityCode = null;
        this.cityName = null;
      }
    },
    dataRecaptcha(value) {
      this.dataCaptcha = value;
    },
    removeDataRecaptcha() {
      this.dataCaptcha = '';
    },
    pushDataLayer() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'main_ecomm_FORM_SENT_PM',
      });
      console.log('MiM_FORM_SENT_RA');
      window.dataLayer.push({
        event: 'MiM_FORM_SENT_RA',
      });
    },
    submit() {
      if (ym) {
        ym(26117928, 'reachGoal', 'mimnew_start_lead');
      }
      this.$v.$touch();

      if (this.checkedCheckbox && !this.$v.$invalid) {
        const dataFields = _.extend({
          // defaults
        }, {
          name: this.valueName,
          phone: this.valuePhone,
          email: this.valueEmail,
          captcha: this.dataCaptcha,
          agreement: this.checkedCheckbox,
          organization: this.valueOrganization,
          site: this.valueSite,
          cityCode: this.cityCode,
          cityName: this.cityName,
          socialMedia: this.valueSocialMedia,
        });

        if (this.csrf_token) {
          dataFields.csrf_token = this.csrf_token;
        }

        this.buttonActive = false;
        this.buttonLoad = true;

        if (document.referrer) {
          dataFields.referer = document.referrer;
        }

        if (this.valueSubscription) {
          dataFields.subscription = this.valueSubscription;
        }

        const params = new URLSearchParams(window.location.search);
        params.forEach((value, key) => {
          dataFields[key] = value;
        });

        axios({
          method: 'post',
          url: `/form/${this.formType}`,
          data: formData(dataFields),
        }).then((response) => {
          if (response.data.url) {
            if (typeof ym !== 'undefined') {
              ym(57872296, 'reachGoal', 'mim_send_form');
            }
            this.pushDataLayer();

            setTimeout(() => {
              window.location = response.data.url;
            }, 10);
          } else if (response.data.error) {
            this.dataError = response.data;
            if (response.data.messages) {
              const formErrorEvent = new CustomEvent('submit-error', { detail: { messages: response.data.messages } });
              document.dispatchEvent(formErrorEvent);
            }
          } else {
            const form = this.$refs.formPartners;
            const detailObject = { form, response };
            const formSuccessEvent = new CustomEvent('submit-success', { detail: detailObject });
            document.dispatchEvent(formSuccessEvent);

            if (typeof ym !== 'undefined') {
              ym(57872296, 'reachGoal', 'mim_send_form');
            }

            this.pushDataLayer();
          }
        });

        this.buttonActive = true;
        this.buttonLoad = false;
        this.$refs.recaptcha.reset();
      }
    },
    onBlurAddressSite() {
      this.$v.valueSite.$touch();
      this.showTextAddressSite = false;
    },
    onBlurSocialMedia() {
      this.$v.valueSocialMedia.$touch();
      this.showSocialMedia = false;
    },
  },
  validations: {
    valueEmail: {
      validateEmail,
    },
    valuePhone: {
      validatePhone,
    },
    valueSite: {
      validateSite,
    },
    valueSocialMedia: {
      validateSocialMediaSymbols,
      validateLength: (val) => !val || (val.length >= 4 && val.length <= 100),
    },
  },
};
</script>
<style lang="scss">
  @import 'FormCooperationEcommerce.scss';
</style>
